module.exports = __webpack_public_path__ + "img/at.362fe867.svg";